/**
 * Url-слой стека модальных окон: окно с содержимым по ссылке. Сидит поверх базового window.openModalWindow
 * и добавляет загрузку GET-ом: до показа окна в .modal-body ставится крутилка-плейсхолдер, а после того как
 * окно стало видимым (shown.bs.modal) — запускается запрос; ответ вставляется единственной точкой
 * window.openModalWindowSetContent с хуками onBeforeContentInsert / onAfterContentInsert вокруг.
 * Повторная загрузка открытого окна — алиас кнопки «reload-content».
 *
 * Плагины слоя (1 файл — 1 функция) лежат в open-modal-url/ и регистрируются в window.openModalWindowFunctions:
 *   load-content.js    — служебный GET содержимого по config.url,
 *   reload-content.js  — алиас «reload-content»: крутилка + повторный GET открытого окна,
 *   location-reload.js — алиас «location-reload»: перезагрузить страницу (location.reload).
 */

require("./open-modal-url/load-content");     // служебная загрузка: GET по config.url → SetContent / alert об ошибке
require("./open-modal-url/reload-content");   // алиас «reload-content» для кнопок футера и повторных подгрузок
require("./open-modal-url/location-reload");  // алиас «location-reload»: перезагрузить страницу

/**
 * Открывает окно с контентом по ссылке: базовое openModalWindow + крутилка до показа и GET после показа.
 * element — элемент-триггер (сырой DOM-узел из jQuery-обработчика либо объект события); null, если триггера нет
 *           (тогда url обязательно в config.url).
 * config  — опции слоя: url, onBeforeContentInsert / onAfterContentInsert (хуки вокруг вставки контента — и
 *           статического, и из ответа GET); остальные опции базового окна (title/size/buttons/хуки show-hide)
 *           проходят вниз как есть. Разрешённый url записывается обратно в cfg, поэтому хуки и кнопки получают
 *           готовое значение. Статический content имеет приоритет над url: окно открывается без запроса,
 *           крутилка не ставится.
 */
window.openModalUrl = function (element, config) {
    let defaults = {
        url: null,                    // URL содержимого; если не передан — data-url/href элемента-триггера
        onBeforeContentInsert: null,  // function(config, html) — перед вставкой контента в .modal-body (статического или из ответа GET)
        onAfterContentInsert: null    // function(config, html) — после вставки контента
    };

    let cfg = Object.assign({}, defaults, config || {});

    // Если вместо элемента прилетел объект события — выдёргиваем нативный триггер (jQuery 3.x: e.currentTarget).
    element = (element && element.currentTarget) ? element.currentTarget : element;

    // URL содержимого: из config → иначе data-url/href элемента-триггера. Разрешённый url — обратно в cfg.
    let trigger = (element && jQuery(element).length) ? jQuery(element) : null;
    cfg.url = cfg.url || (trigger && (trigger.attr("data-url") || trigger.attr("href")));

    // Контент по ссылке: крутилка до показа, GET после. Статический content — без запроса и крутилки.
    if (cfg.url) {
        let userOnBeforeOpen = cfg.onBeforeOpen;
        let userOnAfterOpen = cfg.onAfterOpen;

        // До показа (show.bs.modal): крутилка-плейсхолдер, чтобы окно не проявлялось пустым во время fade-in.
        cfg.onBeforeOpen = function (config2, event) {
            config2.modal.find(".modal-body").html('<div class="text-center py-4"><div class="spinner-border text-primary" role="status"></div></div>');
            if (typeof userOnBeforeOpen === "function") {
                userOnBeforeOpen(config2, event);
            }
        };

        // После показа (shown.bs.modal): запускаем GET; ответ вставит load-content с хуками вокруг.
        cfg.onAfterOpen = function (config2, event) {
            window.openModalWindowFunctions["load-content"](null, config2);
            if (typeof userOnAfterOpen === "function") {
                userOnAfterOpen(config2, event);
            }
        };
    } else if (typeof cfg.content !== "string") {
        console.warn("[modal-url] Не указан URL: передайте config.url или добавьте data-url/href на элемент-триггер");
    }

    window.openModalWindow(element, cfg);
};
